import { jsx } from 'react/jsx-runtime';
import '../LoadingPlaceholder/index.js';
import '../Navbar/index.js';
import '../SplitLayout/index.js';
import { SidebarWrapper, LoadingSidebarWorkspace, LoadingWrapper } from './LoadingWorkspaceSidebarLayout.styles.js';
import { SplitLayout } from '../SplitLayout/SplitLayout.js';
import { Navbar } from '../Navbar/Navbar.js';
import { LoadingPlaceholder } from '../LoadingPlaceholder/LoadingPlaceholder.js';

const LoadingWorkspaceSidebarLayout = () => (jsx(SplitLayout, Object.assign({ header: jsx(Navbar, {}), sidebar: jsx(SidebarWrapper, { children: jsx(LoadingSidebarWorkspace, {}) }), footer: null }, { children: jsx(LoadingWrapper, { children: jsx(LoadingPlaceholder, { size: "64px" }) }) })));

export { LoadingWorkspaceSidebarLayout };
